import { useQuery } from '@tanstack/react-query';
import { fetchAddOnGroup } from '../services/addonGroups';
import { addonGroupKeys } from './useAddOnGroupsQuery';

export function useAddOnGroupQuery(id: string | undefined) {
    return useQuery({
        queryKey: addonGroupKeys.detail(id ?? ''),
        queryFn:  () => fetchAddOnGroup(id!),
        enabled:  !!id,
    });
}
